// extracted by mini-css-extract-plugin
module.exports = {"sort-box":"SortBox_sort-box__xikWv","sort":"SortBox_sort__3U7a6","total-result":"SortBox_total-result__15MeT","status":"SortBox_status__1sgsi"};